"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderTagApi = _interopRequireWildcard(require("@/api/orderTagApi.js"));
var _validate = require("@/utils/validate");
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var storeApi = _interopRequireWildcard(require("@/api/store"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      visible: false,
      details: {},
      // 预留一份数据
      productId: '',
      tagOption: [],
      pram: {},
      initloading: false
    };
  },
  props: {
    bindType: {
      // 打标类型 0: 订单列表打标 1: 三方订单打标
      type: [Number, String],
      default: 0
    }
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit(productId) {
      this.productId = productId;
      this.pram = {};
      this.visible = true;
      this.getAllTags();
    },
    handerSubmit: (0, _validate.Debounce)(function () {
      var _this$pram,
        _this$pram$labelIds,
        _this = this;
      this.loading = true;
      dangaoActApi.saveCakeTag({
        productId: this.productId,
        labelIds: (_this$pram = this.pram) === null || _this$pram === void 0 ? void 0 : (_this$pram$labelIds = _this$pram.labelIds) === null || _this$pram$labelIds === void 0 ? void 0 : _this$pram$labelIds.join(',')
      }).then(function (data) {
        _this.$message.success('操作成功');
        _this.loading = false;
        _this.visible = false;
        _this.$emit('doRefresh');
      }).catch(function () {
        _this.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getAllTags: function getAllTags() {
      var _this2 = this;
      this.visible = true;
      this.initloading = true;
      this.tagOption = [];
      storeApi.getLabelApi({
        type: 3
      }).then(function (res) {
        _this2.tagOption = res || [];
        _this2.initloading = false;
      }).catch(function (err) {
        _this2.initloading = false;
      });
    }
  }
};